import React from 'react';

import { applicationTitles } from '../../localization/en-us/applicationTitles';

import classes from './Title.module.css';

const subscriptions = props => {
    return (
        <div className={classes.TitleBox}>
            <img src="/assets/images/subscriptionsIconColor.svg" alt="Subscriptions" />
            <p>{applicationTitles.subscriptions}</p>
        </div>
    );
};

export default subscriptions;
